import { Link } from "react-router-dom";

/**
 * Dark, full-bleed intro band for the /listing-plans page — breadcrumb,
 * heading, supporting copy and a "simple yearly pricing" pill, matching the
 * reference directory's pricing hero.
 */
export default function PlansHero() {
  return (
    <section className="border-b border-background-200 bg-primary-900">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-xs text-background-300">
          <Link to="/" className="transition-colors hover:text-accent-300 cursor-pointer">
            Home
          </Link>
          <i className="ri-arrow-right-s-line text-sm"></i>
          <span className="font-medium text-background-100">Listing plans</span>
        </nav>
        <div className="mt-5 max-w-3xl">
          <h1 className="font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-4xl">
            Plans that grow with your business
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
            Start with a free listing and upgrade whenever you are ready for more visibility, leads and customer
            reach across the Mysore region. No hidden charges, cancel anytime.
          </p>
        </div>
        <p className="mt-7 inline-flex items-center gap-2 rounded-full border border-primary-700 bg-primary-950/40 px-5 py-2 text-sm font-semibold text-background-100">
          <i className="ri-calendar-check-line text-base text-accent-400"></i>
          Simple yearly pricing — one payment covers 12 months
        </p>
      </div>
    </section>
  );
}